import React from 'react';

const Positive = ({ width, height, fill = '#32C24D' }) => (
    <svg width={width} height={height} viewBox="0 0 100 100">
        <path
            fill={fill}
            fillRule="nonzero"
            d="M50 0c27.614 0 50 22.386 50 50s-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0zm0 5C25.147 5 5 25.147 5 50s20.147 45 45 45 45-20.147 45-45S74.853 5 50 5zm28.716 24.182a2.5 2.5 0 0 1 .22 3.4l-.118.134L41.17 72.583 23.236 54.718a2.5 2.5 0 0 1 3.397-3.664l.131.122 14.296 14.24 34.122-36.132a2.5 2.5 0 0 1 3.534-.102z"
        />
    </svg>
);

export default Positive;
